var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card__avatar"},[(_vm.practice)?_c('common-rating-avatar',{attrs:{"showPracticeAvatar":true,"rating":_vm.practice.professionalRating,"user":_vm.practice,"size":_vm.avatarSize,"isUserProfileLinkEnabled":false}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }